module.exports = __webpack_public_path__ + "images/emoji/family.3303303cafaf90eba34d.png";